import { SubSection } from "context/BlogContext";
import * as Yup from "yup";

export const paragraphInitialValues = (subSection: SubSection) => ({
  title: subSection?.title || "",
  language: subSection?.attrs?.type || "",
  code: subSection?.attrs?.text || "",
});

export const paragraphValidationSchema = Yup.object({
  language: Yup.string().required("Language is required"),
  code: Yup.string().required("code is required"),
});
